import React from 'react'

export default function NotificationItem(props) {
    // props
    const {
        dataItem,

        handleNotificationClick,
        handleNotificationChange
    } = props

    return (
        <React.Fragment>
            {
                /* item */
                (dataItem?.event_name === "favorite_products_reminder") ? ( // FAVORITE PRODUCTS REMINDER
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Favorite products reminder
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent to a customer who added products to Favorites but has not purchased them within 3 days.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "abandoned_cart") ? ( // ABANDONED CART RECOVERY
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Abandoned cart recovery
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            If a customer abandons their cart, Cloud Commerce will send a recovery email to remind the shopper about their unfinished order.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "order_feedback_request") ? ( // FEEDBACK REQUEST
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Feedback request
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent to a client after the order is delivered to ask for the customer’s feedback and to initiate more personal communication.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "loyalty_appreciation") ? ( // LOYALTY APPRECIATION
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Loyalty appreciation
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent to a customer a day after they paid their second and all subsequent orders to express the appreciation of the customer’s loyalty.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "inactive_customer_reminder") ? ( // INACTIVE CUSTOMER REMINDER
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Inactive customer reminder
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent to a customer 6 months after their last order to remind them about your store.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
        </React.Fragment>
    )
}
